function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_EVENTREACTION_REQUEST = "POST_EVENTREACTION_REQUEST";
export var POST_EVENTREACTION_SUCCESS = "POST_EVENTREACTION_SUCCESS";
export var POST_EVENTREACTION_FAILURE = "POST_EVENTREACTION_FAILURE";
export var RESET_POST_EVENTREACTION = "RESET_POST_EVENTREACTION";
export var postEventReaction = function postEventReaction(eventReaction) {
  return _defineProperty({
    eventReaction: eventReaction
  }, CALL_API, {
    types: [POST_EVENTREACTION_REQUEST, POST_EVENTREACTION_SUCCESS, POST_EVENTREACTION_FAILURE],
    endpoint: "eventReactions",
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(eventReaction),
      credentials: "same-origin"
    }
  });
};
export var resetPostEventReaction = function resetPostEventReaction() {
  return {
    type: RESET_POST_EVENTREACTION
  };
};
export var DELETE_EVENTREACTION_REQUEST = "DELETE_EVENTREACTION_REQUEST";
export var DELETE_EVENTREACTION_SUCCESS = "DELETE_EVENTREACTION_SUCCESS";
export var DELETE_EVENTREACTION_FAILURE = "DELETE_EVENTREACTION_FAILURE";
export var RESET_DELETE_EVENTREACTION = "RESET_DELETE_EVENTREACTION";
export var deleteEventReaction = function deleteEventReaction(eventReaction) {
  return _defineProperty({
    eventReaction: eventReaction
  }, CALL_API, {
    types: [DELETE_EVENTREACTION_REQUEST, DELETE_EVENTREACTION_SUCCESS, DELETE_EVENTREACTION_FAILURE],
    endpoint: "reactions/".concat(eventReaction.id),
    init: {
      method: "DELETE",
      credentials: "same-origin"
    }
  });
};
export var resetDeleteEventReaction = function resetDeleteEventReaction() {
  return {
    type: RESET_DELETE_EVENTREACTION
  };
};